import { getInitialState } from './initialState';

const initialState = getInitialState();

const fetchReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'fetch/masses/loading':
      return {
        ...state,
        masses: {
          anytimeFetched: true,
          loading: true,
          error: false,
        },
      };
    case 'fetch/masses/finished':
      return {
        ...state,
        masses: {
          ...state.masses,
          loading: false,
          error: false,
        },
      };
    case 'fetch/masses/fail':
      return {
        ...state,
        masses: {
          ...state.masses,
          loading: false,
          error: action.payload,
        },
      };

    default:
      return state;
  }
};

export default fetchReducer;
